import JobPreferencesForm from "@/components/Forms/JobPreferencesForm";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_provider/provider/jobs/preferences/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="mx-auto w-full max-w-4xl space-y-4">
      <div className="mb-4">
        <Button variant="ghost" size="sm" asChild>
          <Link
            to="/provider/jobs"
            className="text-primary hover:bg-primary/5 hover:text-primary"
          >
            <ArrowLeft className="h-5 w-5 mr-1" />
            Back to Job Portal
          </Link>
        </Button>
      </div>
      <div className="w-full rounded-2xl border border-slate-200 bg-white p-5 shadow-xs sm:p-8">
        <h2 className="mb-2 text-xl font-semibold tracking-tight text-slate-900">
          Job Preferences
        </h2>
        <p className="mb-6 text-sm leading-relaxed text-slate-600">
          Fill in your shift preferences and we will let you know when shifts
          are available
        </p>
        <JobPreferencesForm />
      </div>
    </div>
  );
}
